import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";

import moment from "moment";

import { getDocumentslist } from "../../../StateManagement/Reducers/DocumentsState";

import { FaPlus } from "react-icons/fa";
import { BsChevronDown } from "react-icons/bs";

import UploadDocument from "../UploadDocument";
import Pagination from "../../StyledComponents/Pagination";
import DocumentTable from "./DocumentTable";

import { Div, Button, Text } from "../../StyledComponents";
import { TitleDiv, DropdownList, DropdownContent } from "./styles";
import { Select, DatePicker } from "antd";
const { RangePicker } = DatePicker;

const DocumentList = ({ documenthead, setdocumenthead }) => {
  // ------------------------------ State And Variables Start------------------------ //
  const dispatch = useDispatch();

  const inputNotRef = useRef(null);

  const [drop, setDrop] = useState(false);
  const [isupload, setIsUpload] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(10);

  const DocumentsList = useSelector((state) => state.Document.Documentlist);
  const [filteredDocs, setFilteredDocs] = useState(null);

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const dataSource = filteredDocs !== null ? filteredDocs : DocumentsList;
  const currentPosts = dataSource.slice(indexOfFirstPost, indexOfLastPost);
  const howManyPages = Math.ceil(dataSource.length / postsPerPage);

  const [filterType, setFilterType] = useState("");
  const [filterStatus, setFilterStatus] = useState("");
  const [filterDate, setFilterDate] = useState(null);

  // ------------------------------State And Variables End------------------------ //

  // ------------------------------Functions Start------------------------------- //

  const documentlistselect = (val) => {
    if (val === "1") {
      setdocumenthead("Documents");
      dispatch(getDocumentslist({ filtertype: "All Documents" }));
    }
    if (val === "2") {
      setdocumenthead(" Signed Documents");
      dispatch(getDocumentslist({ filtertype: "Signed Documents" }));
    }
    if (val === "3") {
      setdocumenthead("New Documents");
      dispatch(getDocumentslist({ filtertype: "New Documents" }));
    }

    if (val === "4") {
      setdocumenthead("In Review Dcouments");
      dispatch(getDocumentslist({ filtertype: "In Review Dcouments" }));
    }
    if (val === "5") {
      setdocumenthead("Lab Results");

      dispatch(getDocumentslist({ filtertype: "Lab Results" }));
    }
  };

  const handleClick1 = (e) => {
    if (inputNotRef.current && !inputNotRef.current.contains(e.target)) {
      setDrop(false);
    }
  };
  const handleFilterUpdate = () => {
    const filtered = DocumentsList.filter((doc) => {
      let typeMatch = true;
      let statusMatch = true;
      let dateMatch = true;

      // 1. Evaluate Type Filter
      if (filterType && filterType !== "") {
        let displayType = "Other"; // Defaulting to "Other"

        // Replicate table's Type logic securely
        if (doc.screening_form || doc.assess_form) {
          displayType = "Assessment";
        } else if (doc.document_type) {
          displayType = doc.document_type;
        } else if (doc.form_name && typeof doc.form_name === 'string' && doc.form_name.toLowerCase().includes("intake")) {
          // Added a safe string check to prevent crashes if form_name is null
          displayType = "Intake";
        }

        // Catch mismatches (e.g., table says "Others", dropdown says "Other")
        if (displayType.toLowerCase() === "others") displayType = "Other";

        typeMatch = displayType.toLowerCase() === filterType.toLowerCase();
      }

      // 2. Evaluate Status Filter
      if (filterStatus && filterStatus !== "") {
        let displayStatus = doc.status || "";
        const isAssessment = doc.screening_form || doc.assess_form;

        const requiresSign = doc.req_pat_sign === "yes" || doc.req_pat_sign === 1 || doc.req_pat_sign === "1";

        const isActionableForm = ((doc.is_share === "yes" && doc.tags !== "By Provider" && doc.tags !== "PCE") || isAssessment)
          && doc.note_type !== 4
          && (doc.has_fields === true || requiresSign);

        const isSaved = doc.temp_url !== null && doc.temp_url !== "";

        // Perfectly replicate DocumentTable's Status logic
        if (isActionableForm) {
          if (doc.status === "New" && !isSaved) {
            displayStatus = "Pending";
          } else if (requiresSign && !isAssessment) {
            if (doc.status === "Signed" || doc.status === "Locked") {
              displayStatus = "Signed";
            } else if (doc.status === "In Review") {
              displayStatus = "In Review";
            } else {
              displayStatus = "Unsigned";
            }
          } else {
            if (doc.status === "In Review") {
              displayStatus = "In Review";
            } else {
              displayStatus = "Completed";
            }
          }
        } else {
          if (doc.status === "Locked" || doc.status === "Signed") {
            if (doc.signed === "Yes") {
              displayStatus = "Signed";
            } else {
              displayStatus = "Completed";
            }
          }
        }

        statusMatch = (displayStatus || "").toLowerCase() === filterStatus.toLowerCase();
      }

      // 3. Evaluate Date Filter (The source of the bug)
      if (filterDate && filterDate.length === 2 && filterDate[0] && filterDate[1]) {
        // 🔥 SAFELY CONVERT Ant Design's date object into a standard Javascript Date, then into a Moment object
        const startDate = moment(filterDate[0].toDate ? filterDate[0].toDate() : filterDate[0]);
        const endDate = moment(filterDate[1].toDate ? filterDate[1].toDate() : filterDate[1]);

        // Use doc.date since that is what the table visually uses for "Create Date"
        const docDateStr = doc.date_submit || doc.date || doc.update_date;
        const docDate = moment(docDateStr);

        if (docDate.isValid() && startDate.isValid() && endDate.isValid()) {
          dateMatch = docDate.isSameOrAfter(startDate, 'day') && docDate.isSameOrBefore(endDate, 'day');
        } else {
          dateMatch = false; // Exclude if date is invalid
        }
      }

      // ONLY return the document if it successfully passes ALL active filters
      return typeMatch && statusMatch && dateMatch;
    });

    setFilteredDocs(filtered);
    setCurrentPage(1);
  };

  // ------------------------------Functions End-------------------------- //
  // ------------------------------ useEffect Start------------------------------------------------------------- //
  useEffect(() => {
    document.addEventListener("mouseup", handleClick1);

    return () => {
      document.addEventListener("mouseup", handleClick1);
    };
  }, []);

  useEffect(() => {
    setFilteredDocs(null);
  }, [DocumentsList]);
  // ------------------------------ useEffect End------------------------------------------------------------- //

  return (
    <>
      {/* <TitleDiv> */}
      {/* <Div
          display="flex"
          flexDirection="column"
          alignItems="center"
          onClick={() => setDrop(!drop)}
          position="relative"
        >
          <Text
            textAlign="left"
            mb="0px"
            mt="0px"
            fontWeight="400"
            fontSize="14px"
            lineHeight="19px"
            color="#7d8592"
          >
            Document list
          </Text>
          <Text
            fontWeight="500"
            fontSize="20px"
            lineHeight="28px"
            color="#000000"
            mb="0px"
            mt="0px"
            textAlign="left"
            svgmarginLeft="6px"
            svgmarginTop="7px"
            svgfontSize="12px"
          >
            {documenthead}

            <BsChevronDown id="doc_al-svg_log" />
          </Text>
          <DropdownContent
            marginLeft="-11px"
            marginTop="30px"
            left="0px"
            top="50%"
            width="170px"
            display={drop.toString()}
            ref={inputNotRef}
          >
            <DropdownList
              padding="10px"
              onClick={() => documentlistselect("1")}
            >
              Documents
            </DropdownList>
            <DropdownList
              padding="10px"
              onClick={() => documentlistselect("2")}
              id="doc_dd-li_snd"
            >
              Signed Documents
            </DropdownList>
            <DropdownList
              padding="10px"
              onClick={() => documentlistselect("3")}
              id="doc_dd-li_usnd"
            >
              New / UnSigned Documents
            </DropdownList>
            <DropdownList
              padding="10px"
              onClick={() => documentlistselect("4")}
              id="doc_dd-li_rvw"
            >
              In Review Dcouments
            </DropdownList>
            <DropdownList
              padding="10px"
              onClick={() => documentlistselect("5")}
              id="doc_dd-li_rvw"
            >
              Lab Results
            </DropdownList>
          </DropdownContent>
        </Div>

        <Button
          padding="12px 20px"
          height="40px"
          background="#2C7BE5"
          hoverBackColor="#005FB2"
          color="#fff"
          fontWeight="500"
          borderRadius="4px"
          cursor="pointer"
          justifyContent="center"
          alignItems="center"
          display="flex"
          svgfontSize="16px"
          svgmarginRight="10px"
          className="save_active"
          onClick={() => setIsUpload(true)}
          id="doc_upd-btn"
        >
          <FaPlus /> Upload Document
        </Button> */}
      {/* </TitleDiv> */}
      <Div
        width="100%"
        background="#F5F6F8"
        borderBottom="1px solid #E4E6EB"
        padding="12px 20px 2px 8px"
      >
        <Div display="flex" gap="32px" background="#F5F6F8">
          <Div
            position="relative"
            paddingBottom="10px"
            cursor="pointer"
            background="#F5F6F8"
            onClick={() => {
              setdocumenthead("Documents");
              dispatch(getDocumentslist({ filtertype: "All Documents" }));
            }}
          >
            <Text
              fontWeight="500"
              fontSize="18px"
              color={documenthead === "Documents" ? "#2C7BE5" : "#6B7280"}
              margin="0"
              width="auto"
              display="inline-block"
              background="#F5F6F8"
            >
              Documents
            </Text>

            {documenthead === "Documents" && (
              <Div
                position="absolute"
                bottom="0"
                left="0"
                width="100%"
                height="2px"
                background="#2C7BE5"
              />
            )}
          </Div>

          <Div
            position="relative"
            paddingBottom="10px"
            cursor="pointer"
            background="#F5F6F8"
            onClick={() => {
              setdocumenthead("Lab Results");
              dispatch(getDocumentslist({ filtertype: "Lab Results" }));
            }}
          >
            <Text
              fontWeight="500"
              fontSize="18px"
              color={documenthead === "Lab Results" ? "#2C7BE5" : "#6B7280"}
              margin="0"
              width="auto"
              display="inline-block"
              background="#F5F6F8"
            >
              Lab Result
            </Text>

            {documenthead === "Lab Results" && (
              <Div
                position="absolute"
                bottom="0"
                left="0"
                width="100%"
                height="2px"
                background="#2C7BE5"
              />
            )}
          </Div>
        </Div>
      </Div>
      <Div
        width="100%"
        background="#FFFFFF"
        borderRadius="12px"
        padding="10px 0 20px 0"
        marginTop="6px"
      >
        {/* Document List Heading */}
        <Div
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          padding="0 10px"
          marginBottom="10px"
        >
          <Text fontSize="18px" fontWeight="400">
            <h3>
              {documenthead === "Lab Results"
                ? "Reports List"
                : "Document List"}
            </h3>
          </Text>

          <Button
            padding="8px 20px"
            height="36px"
            background="#2C7BE5"
            color="#fff"
            borderRadius="6px"
            display="flex"
            alignItems="center"
            className="save_active"
            onClick={() => setIsUpload(true)}
            style={{ whiteSpace: "nowrap" }}
          >
            Upload Document
          </Button>
        </Div>
        {documenthead === "Documents" && (
          <Div
            width="100%"
            display="flex"
            alignItems="center"
            gap="16px"
            padding="8px 20px"
            background="#F5F5F5"
            borderRadius="0"
            marginTop="2px"
            marginBottom="2px"
          >
            {/* Filter by Type */}
            <Select
              placeholder="Filter by Type"
              style={{ width: 140 }}
              allowClear
              onChange={(value) => setFilterType(value)}
            >
              <Select.Option value="Assessment">Assessment</Select.Option>
              <Select.Option value="Intake">Intake</Select.Option>
              <Select.Option value="Other">Other</Select.Option>
            </Select>

            {/* Filter by Status */}
            <Select
              placeholder="Filter by Status"
              style={{ width: 140 }}
              allowClear
              onChange={(value) => setFilterStatus(value)}
            >
              <Select.Option value="New">New</Select.Option>
              <Select.Option value="Pending">Pending</Select.Option>
              <Select.Option value="Viewed">Viewed</Select.Option>
              <Select.Option value="In Review">In Review</Select.Option>
              <Select.Option value="Unsigned">Unsigned</Select.Option>
              <Select.Option value="Signed">Signed</Select.Option>
              <Select.Option value="Completed">Completed</Select.Option>
            </Select>

            {/* Date Range */}

            {/* Last 7 days text */}
            <Div>
              <Text
                fontSize="13px"
                color="#6B7280"
                margin="0"
                background="#F5F5F5"
              >
                Last 7 days
              </Text>
            </Div>

            {/* Date Range Picker */}
            <Div>
              <RangePicker
                format="MM-DD-YYYY"
                onChange={(dates) => setFilterDate(dates)}
                style={{ width: "260px" }}
              />
            </Div>
            {/* Update Button */}
            <Button
              padding="6px 16px"
              background="#2C7BE5"
              color="#fff"
              borderRadius="4px"
              fontSize="14px"
              onClick={handleFilterUpdate}
            >
              Update
            </Button>
          </Div>
        )}

        <Div padding="0px 0px 10px 0px">
          <DocumentTable
            docTableData={currentPosts}
            documenthead={documenthead}
          />
        </Div>

        <UploadDocument
          show={isupload}
          close={() => setIsUpload(false)}
          setdocumenthead={setdocumenthead}
        />

        {currentPosts.length === 0 || howManyPages <= 1 ? (
          ""
        ) : (
          <Pagination pages={howManyPages} setCurrentPage={setCurrentPage} />
        )}
      </Div>
    </>
  );
};

export default DocumentList;
